import { useMutation, useQueryClient } from '@tanstack/react-query';
import { revokeInvite } from '../api/userManagementApi';
import { userKeys } from './userKeys';

/**
 * Mutation hook for revoking an invitation.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useRevokeInvite() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (invitationId: string) => revokeInvite(invitationId),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userKeys.pendingInvites() });
    },
  });
}
